import React from 'react';
import styles from './index.less';

const tradeTitle = {
  ctrip: '携程',
  meituan: '美团',
  wx_mini: '微信小程序'
};

const MessageRedbookTradeBusiness = props => {
  const { data = {} } = props;
  const { title, image, sub_title, link_platform } = data;

  return (
    <div className={styles.card}>
      <div style={{ fontSize: '12px', color: '#9095AB', marginBottom: '8px' }}>{tradeTitle[link_platform]}</div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img style={{ width: '40px', height: '40px', marginRight: '10px', borderRadius: '50%' }} src={image} alt='' />
        <div>
          <div style={{ fontSize: '14px', color: '#1D2754' }}>{title}</div>
          <div style={{ fontSize: '14px', color: '#6F7592' }}>{sub_title}</div>
        </div>
      </div>
    </div>
  );
};

export default MessageRedbookTradeBusiness;
